module.exports = __webpack_public_path__ + "assets/img/arrow_head.0f36f5c9.svg";